<template>
  <div class="content" :style='{width:(this.$store.state.windowwidth-this.$store.state.leftBlockWidth-this.$store.state.indexPadding*2)+"px"}'>
      <div class="common-items-center common-space-between">
          <div class="common-items-center"> 
            <InputBlock title="工厂类型" >
                <el-input v-model="name" :size="this.$store.state.inputSize" placeholder="请输入工厂类型" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'/>
            </InputBlock>
            <SelectBlock ref="enabled"   keyVal="enabled"       title="工厂状态"    right="20"    paddButtom="0"   :size="this.$store.state.inputSize"   @getVal="getVal" width="150" placeholder="请选择" :options="list" />
            <el-button size="small" type="primary" icon="el-icon-search" @click="serachBtn">查询</el-button>
            <el-button size="small" type="danger"  icon="el-icon-refresh-left" @click="resetBtn">重置</el-button>
          </div>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="addBtn">新增</el-button>
       </div>
       <div class="warp-table">
        <el-table  :data="tableData" :empty-text="this.$store.state.tableEmpty" :size="this.$store.state.tableSize" ref="giftTable" style="width: 100%"  row-key="id"  :height="this.$store.state.windowHeight-270">
            <el-table-column align="left" header-align="left" prop="date"       label="序号"        width="100">
                <template slot-scope="scope">{{scope.$index+1}}</template>
            </el-table-column>
            <el-table-column align="left" header-align="left" :show-overflow-tooltip="true" prop="name"       label="工厂类型"      width="200"></el-table-column>
            <el-table-column align="left" header-align="left" prop="marks"      label="类型描述"   ></el-table-column>
            <el-table-column align="left" header-align="left" prop="sort"       label="排序"    width="100"> </el-table-column>
            <el-table-column align="left" header-align="left" prop="createTime" label="更新时间"    width="200"></el-table-column>
            <el-table-column align="left" header-align="left" prop="operator"       label="最近操作人"  width="180"></el-table-column>
            <el-table-column align="center" header-align="center" prop="city"       label="状态"       width="200">
              <template slot-scope="scope">
                <div class="common-space-around">
                       <span v-if="scope.row.enabled == 0" class="disable">禁用</span>
                       <span v-else-if="scope.row.enabled == 1" class="open">启用</span>
                       <span v-else>-</span>
                </div>
              </template>  
            </el-table-column>
            
            <el-table-column align="center" header-align="center" fixed="right"     label="操作"       width="100">
              <template slot-scope="scope" >
                <div class="common-space-around operate">
                    <el-link  :underline="false"  @click="ediBtn(scope.row)" type="primary" size="mini">编辑</el-link>
                    <el-popconfirm title="确定删除吗？" @confirm="deleteBtn(scope.row)">
                        <el-link  :underline="false" slot="reference"  type="danger" size="mini">删除</el-link>
                    </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <Paging @getPage="getPage" :total="total" :pageNo="current" :size="size"/>
       </div>
       <AddBlock ref="add"></AddBlock>
       <EditorBlock ref="edi"></EditorBlock>
  </div>
</template>

<script>
import AddBlock from './block-type/add-block.vue'
import EditorBlock from './block-type/editor-block.vue'
import {url,userApi} from '@/utils/config'
import {postFun,putFun} from '@/utils/httpFun'
import {scroll} from '../../../components/component-mixin/block-scroll'
export default {
  name: 'index',
  mixins: [scroll],
  components:{
    AddBlock:AddBlock,
    EditorBlock:EditorBlock
  },
  data:()=>({
    input:"",
    value1:true,
    list: [
            { indexNo: '0', selectName: '禁用'}, 
            { indexNo: '1', selectName: '启用'}
          ],
    tableData: [{}],
    name:null,
    enabled:null,
    current:1,
    size:10,
    total:10,
  }),

  created(){
      this.getList()
  },
  methods:{

    //获取所有数据的列表
    async getList(){
        let parms={
            param:{
              isDel:0,   //未删除
              name:this.name,
              enabled:this.enabled
            },
            current:this.current,
            size:this.size
        }
        await postFun(userApi.FACTORYTYPELIST,parms,res=>{
            this.tableData = res.data.records
            this.total = res.data.total
            this.size = res.data.size
            this.current = res.data.current
        })
    },
    
    //查询
    serachBtn(){
      this.getList()
    },

    resetBtn(){
      this.name = null 
      this.enabled = null
      this.$refs.enabled.setVal("")
      this.getList()
    },
  
    //新增弹窗
    addBtn(){
      this.$refs.add.showMessage(this.total);
    },

    //编辑弹窗
    ediBtn(ev){
      this.$refs.edi.showMessage(ev);
    },
    
    //获取输入的值
    getVal(ev){
       if(ev.key=="enabled"){
         this.enabled = ev.indexNo
       }else{
         this.name = ev.val 
       }
    },

    //删除
    async deleteBtn(ev){
       let parms = {
          id:ev.id,
          state:1
       }
       await putFun(userApi.FACTORYTYPEUPDATE,parms,res=>{
          if(res.code==1){
             this.getList()
          }
       })
    },

    //分页
    getPage(ev){
        this.size = ev.pageSize
        this.current = ev.pageNo 
        this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
    .content{
       box-sizing: border-box;
       padding:15px;
    }
    .warp-table{
      margin-top: 15px;
    }
    .operate{
      ::v-deep .el-button--mini{
        padding: 5px 8px;
      }
    }
</style>
